const ACTIONS = {
    SET_SENT_TASKS: 'SET_SENT_TASKS',
    SET_SENT_TASKS_COUNT: 'SET_SENT_TASKS_COUNT',
    SET_SENT_TASKS_STUDY_BINDER_NAMES: 'SET_SENT_TASKS_STUDY_BINDER_NAMES',
    SET_SENT_TASKS_FETCHING: 'SET_SENT_TASKS_FETCHING',
};

export { ACTIONS };